var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcResVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9265 6.60142L16.9265 8.70142C16.6592 8.88855 16.5 9.19434 16.5 9.52066V14.4793C16.5 14.8057 16.6592 15.1114 16.9265 15.2986L19.9265 17.3986C20.5893 17.8625 21.5 17.3884 21.5 16.5793V7.42066C21.5 6.61163 20.5893 6.13748 19.9265 6.60142Z",
    stroke: "#909090",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 17.5V6.5C2.5 4.84315 3.84315 3.5 5.5 3.5H13.5C15.1569 3.5 16.5 4.84315 16.5 6.5V17.5C16.5 19.1569 15.1569 20.5 13.5 20.5H5.5C3.84315 20.5 2.5 19.1569 2.5 17.5Z",
    stroke: "#909090",
    strokeWidth: 1.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 8.5,
    r: 1.9,
    stroke: "#909090",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcResVideo);
export default __webpack_public_path__ + "static/media/ic_res_video.b79cad2ca084a59ee454510fcbd09ad9.svg";
export { ForwardRef as ReactComponent };